import styled from "styled-components";

export const CaptureButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100px;
  height: 150px;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 20px;
  gap: 10px;

  &:hover {
    button {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const CaptureButtonStyle = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

  &:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: scale(1.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

interface CaptureButtonProps {
  onCapture: () => void;
  onCopyText?: () => void;
}

export const CaptureButton = ({
  onCapture,
  onCopyText,
}: CaptureButtonProps) => {
  return (
    <CaptureButtonWrapper>
      {onCopyText && (
        <CaptureButtonStyle onClick={onCopyText} title="Copy Tournament Info">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
          </svg>
        </CaptureButtonStyle>
      )}
      <CaptureButtonStyle onClick={onCapture} title="Screenshot">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
      </CaptureButtonStyle>
    </CaptureButtonWrapper>
  );
};
